import script from "./GuideControlComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideControlComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GuideControlComponent.vue?vue&type=style&index=0&id=59e822d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e822d6"]])

export default __exports__